import React from 'react';
import Styles from './lessons-menu-styles.scss';
import LessonMenuItem from '../lesson-menu-item/lesson-menu-item';
import { CircleSpinner } from '@/presentation/components';
const LessonsMenu = ({ items, isLoading = false, isProgressSaving, isProgressSaved, customTitle = 'My Progress' }) => {
    return (React.createElement("div", { className: Styles.lessonsMenuWrap },
        React.createElement("div", { className: Styles.titleWrap },
            React.createElement("div", { className: Styles.title }, customTitle),
            isProgressSaving && !isProgressSaved && (React.createElement("div", { className: Styles.tagLoadingSaved },
                React.createElement(CircleSpinner, { size: 18 }))),
            isProgressSaved && (React.createElement("div", { className: Styles.tagSaved },
                React.createElement("div", { className: Styles.tagSavedText }, "SAVED")))),
        isLoading && (React.createElement("div", { style: {
                width: '100%',
                height: '100%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                minHeight: '15vh'
            } },
            React.createElement(CircleSpinner, { size: 20 }))),
        React.createElement("div", { className: Styles.items }, items.map((item, index) => (React.createElement(LessonMenuItem, { iconBackground: item === null || item === void 0 ? void 0 : item.iconBackground, key: `Lesson-menu-item-${index}`, status: item === null || item === void 0 ? void 0 : item.status, title: item === null || item === void 0 ? void 0 : item.title, icon: item === null || item === void 0 ? void 0 : item.icon, completed: item === null || item === void 0 ? void 0 : item.completed, onClick: () => {
                if ((item === null || item === void 0 ? void 0 : item.completed) && (item === null || item === void 0 ? void 0 : item.onClick)) {
                    item === null || item === void 0 ? void 0 : item.onClick();
                }
                else {
                    console.log('item onClick disabled');
                }
            } }))))));
};
export default LessonsMenu;
